import { render, staticRenderFns } from "./PackingTaskDetail.vue?vue&type=template&id=30e04c60&scoped=true"
import script from "./PackingTaskDetail.vue?vue&type=script&lang=js"
export * from "./PackingTaskDetail.vue?vue&type=script&lang=js"
import style0 from "./PackingTaskDetail.vue?vue&type=style&index=0&id=30e04c60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e04c60",
  null
  
)

export default component.exports